import Logo from '../Images/PayneftLogo.png'
import React from 'react'

const Newfooter = () => {
  return (
    <div>
      <div className="footer_all">
        <div className="footer max-w-7xl mx-auto flex flex-wrap p-[16px] ">
          <div className="lg:w-3/12 md:w-4/12 sm:w-4/12 w-full">
            <div className="address_sec">
              <img src={Logo} alt="PayNeft" style={{height:"36px", width:"auto", objectFit:"contain"}} />
               
              <ul className="text-white my-4 font-medium">
                <li>S.No. S101, No. 709, 2nd Floor</li>
                <li>Suite No. 115, Spencer Plaza</li>
                <li>Anna Road, Chennai – 600002</li>
                <li>Tamil Nadu, India</li>
              </ul>
              <a href="tel:+919345910837" className='text-white'>+(91) 93459 10837</a>
              <br />
              <a href="https://www.payneft.in" className='text-white' target="_blank"  rel="noreferrer">www.PayNeft.in</a>

            </div>
          </div>
          <div className="lg:w-2/12 md:w-3/12 sm:w-3/12 w-full">
            <div className="quick_link_all">
              <h2>Quick Links</h2>
              <ul>
                <li> <a href="/">Home</a> 
                </li>
                <li> <a href="/features">Features</a></li>
                <li><a href="/pricing">Pricing</a></li>
                <li>Blog</li>
                <li> <a href="/contactus">Contact Us </a></li>
                <li>FAQs</li>
              </ul>
            </div>
          </div>
          <div className="lg:w-2/12 md:w-3/12 sm:w-3/12 w-full">
            <div className="quick_link_all">
              <h2>Company Info </h2>
              <ul>
                <li><a href="/aboutus"> About Us</a></li>
                <li><a href="/careers">Careers</a></li>
                <li><a href="/partnerwithus">Partner with Us</a></li>
                <li><a href="/investor-relations">Investor Relations</a></li>
              </ul>
            </div>
          </div>
          <div className="lg:w-2/12 md:w-3/12 sm:w-3/12 w-full">
            <div className="quick_link_all">
              <h2>Policies  </h2>
              <ul>
                <li><a href="/privacy-Policy">Privacy Policy</a></li>
                <li><a href="/terms-conditions">Terms & Conditions</a></li>
                <li><a href="/security">Security</a></li>
                <li><a href="/certificate">Certificate</a></li>


              </ul>
            </div>
          </div>
          <div className="lg:w-2/12 md:w-3/12 sm:w-3/12 w-full">
            <div className="quick_link_all">
              <h2>Payments  </h2>
              <ul>
                <li>Visa</li>
                <li>Mastercard</li>
                <li>Rupay</li>
                <li>UPI</li>


              </ul>
            </div>
          </div>
          <div className="lg:w-1/12 md:w-3/12 sm:w-3/12 w-full">
            <div className="quick_link_all">
              <h2>Social  </h2>
              <div className="foot_svgs">
                <a href="/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1655_447)">
                    <path d="M15.9965 3.985H18.1875V0.169C17.8095 0.117 16.5095 0 14.9955 0C11.8365 0 9.67252 1.987 9.67252 5.639V9H6.18652V13.266H9.67252V24H13.9465V13.267H17.2915L17.8225 9.001H13.9455V6.062C13.9465 4.829 14.2785 3.985 15.9965 3.985Z" fill="#E3E1D8" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1655_447">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg></a>
                <a href="/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1655_449)">
                    <path d="M18 0H6C2.64 0 0 2.64 0 6V18C0 21.36 2.64 24 6 24H18C21.36 24 24 21.36 24 18V6C24 2.64 21.36 0 18 0ZM21.6 18C21.6 20.04 20.04 21.6 18 21.6H6C3.96 21.6 2.4 20.04 2.4 18V6C2.4 3.96 3.96 2.4 6 2.4H18C20.04 2.4 21.6 3.96 21.6 6V18Z" fill="#E3E1D8" />
                    <path d="M12 6C8.64 6 6 8.64 6 12C6 15.36 8.64 18 12 18C15.36 18 18 15.36 18 12C18 8.64 15.36 6 12 6ZM12 15.6C9.96 15.6 8.4 14.04 8.4 12C8.4 9.96 9.96 8.4 12 8.4C14.04 8.4 15.6 9.96 15.6 12C15.6 14.04 14.04 15.6 12 15.6Z" fill="#E3E1D8" />
                    <path d="M17.9998 7.20005C18.6625 7.20005 19.1998 6.66279 19.1998 6.00005C19.1998 5.33731 18.6625 4.80005 17.9998 4.80005C17.3371 4.80005 16.7998 5.33731 16.7998 6.00005C16.7998 6.66279 17.3371 7.20005 17.9998 7.20005Z" fill="#E3E1D8" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1655_449">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg></a>
                <a href="/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21.6004 21.5999V14.5679C21.6004 11.1119 20.8564 8.47192 16.8244 8.47192C14.8804 8.47192 13.5844 9.52792 13.0564 10.5359H13.0084V8.78392H9.19238V21.5999H13.1764V15.2399C13.1764 13.5599 13.4884 11.9519 15.5524 11.9519C17.5924 11.9519 17.6164 13.8479 17.6164 15.3359V21.5759H21.6004V21.5999Z" fill="#E3E1D8" />
                  <path d="M2.71191 8.78394H6.69591V21.5999H2.71191V8.78394Z" fill="#E3E1D8" />
                  <path d="M4.70439 2.3999C3.43239 2.3999 2.40039 3.4319 2.40039 4.7039C2.40039 5.9759 3.43239 7.0319 4.70439 7.0319C5.97639 7.0319 7.00839 5.9759 7.00839 4.7039C7.00839 3.4319 5.97639 2.3999 4.70439 2.3999Z" fill="#E3E1D8" />
                </svg></a>
              </div>

            </div>
          </div>
        </div>
        <div className="footer_certification_con flex flex-col items-center py-4 border-t border-gray-700/30">
          <a href="/certificate" className="flex items-center space-x-3 text-white hover:text-gray-300 transition-colors">
            <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M23 1v18h-3v-1h2V2H2v16h8v1H1V1zm-7 2H8v1h8zm-2 3V5h-4v1zm-7 5H3v1h4zm0 2H3v1h4zm-4 3h2v-1H3zm14-3a2 2 0 1 1-2-2 2.002 2.002 0 0 1 2 2zm-1 0a1 1 0 1 0-1 1 1.001 1.001 0 0 0 1-1zm.002-4.293a.965.965 0 0 0 1.32.55 1.08 1.08 0 0 1 1.213.207 1.066 1.066 0 0 1 .21 1.21.966.966 0 0 0 .548 1.324 1.064 1.064 0 0 1 0 2.004.965.965 0 0 0-.549 1.323A1.05 1.05 0 0 1 18 16.816v7.046l-3-2.538-3 2.538v-7.046a1.05 1.05 0 0 1-.744-1.49.965.965 0 0 0-.549-1.324 1.064 1.064 0 0 1 0-2.004.966.966 0 0 0 .549-1.324 1.066 1.066 0 0 1 .209-1.21 1.08 1.08 0 0 1 1.212-.206.965.965 0 0 0 1.32-.551 1.064 1.064 0 0 1 2.005 0zm.998 13v-5.04a.93.93 0 0 0-.998.625 1.064 1.064 0 0 1-2.004 0 .93.93 0 0 0-.998-.625v5.039l2-1.692zm-1.94-4.749a1.967 1.967 0 0 1 1.853-1.308 2.12 2.12 0 0 1 .87.197l.058-.091a1.964 1.964 0 0 1 1.116-2.695v-.122a1.966 1.966 0 0 1-1.116-2.695l-.087-.084a1.965 1.965 0 0 1-2.694-1.117h-.12a1.965 1.965 0 0 1-2.694 1.117l-.087.084a1.966 1.966 0 0 1-1.116 2.695v.122a1.964 1.964 0 0 1 1.116 2.695l.058.09a2.12 2.12 0 0 1 .87-.196 1.967 1.967 0 0 1 1.853 1.308L15 17z" fill="currentColor"/>
              <path fill="none" d="M0 0h24v24H0z"/>
            </svg>
            <span className="font-semibold text-sm tracking-wider">ISO/IEC 27001:2022 Certified</span>
          </a>
        </div>

        <div className="footer_reserve_con">
          <p>© {new Date().getFullYear()} PayNeft. All rights reserved.</p>
        </div>


      </div>

    </div>
  )
}

export default Newfooter
